<h2 mat-dialog-title>{{ dialog['title'] }}</h2>
<mat-dialog-content class="mat-typography">
  <div (fileDropped)="onFileDropped($event)" appDnd class="expansion-container drop-container">
    <input #fileDropRef (change)="fileBrowseHandler($event)" accept="{{acceptFileType}}" id="fileDropRef" multiple
           type="file"/>
    <custom-btn [fontSize]="'3rem'" [iconButton]="true" [iconClasses]="'cloud_upload'">
    </custom-btn>
    <h3 class="dnd-h3">Drag and drop files here</h3>
    <h4>or</h4>
    <label for="fileDropRef">Browse for files</label>
  </div>
  <div class="files-list">
    <div *ngFor="let file of files; let i = index" class="single-file">
      <div class="file-icon" style="width: 50px">
        <svg *ngIf="acceptFileType == IMAGE_FILE" class="icon" fill="#000000" version="1.1"
             viewBox="0 -128.5 1281 1281" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="M106.805737 997.298566a80.104302 80.104302 0 0 1-80.104303-80.104303V106.805737a80.104302 80.104302 0 0 1 80.104303-80.104303h1068.057366a80.104302 80.104302 0 0 1 80.104302 80.104303v825.074315a80.104302 80.104302 0 0 1-80.104302 65.418514z"
              fill="#ffffff"></path>
            <path
              d="M1174.863103 53.402868a53.402868 53.402868 0 0 1 53.402868 53.402869v822.404172a53.402868 53.402868 0 0 1-53.402868 41.387223H106.805737a53.402868 53.402868 0 0 1-53.402869-53.402869V106.805737a53.402868 53.402868 0 0 1 53.402869-53.402869h1068.057366m0-53.402868H106.805737a106.805737 106.805737 0 0 0-106.805737 106.805737v810.388526a106.805737 106.805737 0 0 0 106.805737 106.805737h1068.057366a106.805737 106.805737 0 0 0 106.805737-106.805737h-1.335072V106.805737a106.805737 106.805737 0 0 0-106.805737-106.805737z"
              fill="#01122a"></path>
            <path
              d="M299.056063 400.521512a99.863364 99.863364 0 0 1-100.931422-101.465449A100.931421 100.931421 0 1 1 299.056063 400.521512z"
              fill="#d0b993"></path>
            <path
              d="M299.056063 223.491004a73.695958 73.695958 0 0 1 74.764015 74.497001A75.03103 75.03103 0 0 1 299.056063 373.820078a73.428944 73.428944 0 0 1-74.229987-74.764015 75.03103 75.03103 0 0 1 74.229987-75.565059m0-53.402868a128.166884 128.166884 0 1 0 128.166884 127.899869 128.166884 128.166884 0 0 0-128.166884-127.899869z"
              fill="#01122a"></path>
            <path
              d="M198.124641 827.744459v-93.45502l186.91004-186.910039 70.224771 69.957758a51.266754 51.266754 0 0 0 72.360887 0l305.731421-302.794264 252.328553 252.061539v260.605997z"
              fill="#b3bcc6"></path>
            <path
              d="M833.35176 352.191917l224.559061 224.292046V801.043025H224.826076v-53.402869l160.208605-160.208605 51.266753 51.266754a77.968188 77.968188 0 0 0 110.276923 0l286.773403-286.506388m0-65.1515a24.565319 24.565319 0 0 0-17.355932 7.209387L509.196349 599.714211a24.565319 24.565319 0 0 1-34.711864 0l-71.559844-71.559843a24.565319 24.565319 0 0 0-34.711864 0l-189.847197 189.580182a23.230248 23.230248 0 0 0-6.942373 16.554889v95.591135a23.230248 23.230248 0 0 0 23.497262 24.565319h893.162973a23.230248 23.230248 0 0 0 23.230248-23.230248v-267.014341a23.230248 23.230248 0 0 0-6.942373-16.554889L850.707692 293.715776a24.565319 24.565319 0 0 0-17.355932-7.209387z"
              fill="#01122a"></path>
          </g>
        </svg>
        <svg *ngIf="acceptFileType == ANY_FILE" style="enable-background:new 0 0 58 58;" version="1.1"
             viewBox="0 0 58 58" x="0px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
          <polygon points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " style="fill:#EDEADA;"/>
          <g>
            <path d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z"
                  style="fill:#011e41ab;"/>
            <path d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z"
                  style="fill:#011e41ab;"/>
            <path d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z"
                  style="fill:#011e41ab;"/>
            <path d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z"
                  style="fill:#011e41ab;"/>
            <path d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z"
                  style="fill:#011e41ab;"/>
          </g>
          <polygon points="37.5,0 37.5,14 51.5,14 " style="fill:#011e41ab;"/>
        </svg>
        <svg *ngIf="acceptFileType != IMAGE_FILE && acceptFileType != ANY_FILE" style="enable-background:new 0 0 512 512;"
             version="1.1"
             viewBox="0 0 512 512" x="0px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink" y="0px">
          <path d="M438.557,512H19.785c-8.216,0-14.876-6.66-14.876-14.876V256.916c0-8.216,6.66-14.876,14.876-14.876
	s14.876,6.66,14.876,14.876v225.332h389.021v-32.833c0-8.216,6.661-14.876,14.876-14.876c8.215,0,14.876,6.66,14.876,14.876v47.709
	C453.433,505.34,446.772,512,438.557,512z" style="fill:#507C5C;"/>
          <g>
            <polygon points="19.785,177.122 19.785,172.332 175.581,14.876 175.581,177.122 	" style="fill:#CFF09E;"/>
            <rect height="163.65" style="fill:#CFF09E;" width="296.061" x="196.154" y="219.435"/>
          </g>
          <g>
            <path d="M492.215,204.559h-38.782V14.876C453.433,6.66,446.772,0,438.557,0H175.581
		c-0.183,0-0.363,0.021-0.546,0.027c-0.167,0.006-0.332,0.013-0.498,0.025c-0.643,0.046-1.282,0.118-1.909,0.245
		c-0.013,0.003-0.027,0.007-0.042,0.01c-0.617,0.126-1.22,0.305-1.815,0.509c-0.155,0.054-0.309,0.109-0.463,0.167
		c-0.585,0.222-1.159,0.469-1.711,0.762c-0.019,0.01-0.042,0.018-0.061,0.03c-0.568,0.305-1.108,0.66-1.635,1.04
		c-0.135,0.098-0.268,0.196-0.4,0.299c-0.522,0.402-1.028,0.827-1.497,1.3L9.21,161.868c-0.35,0.353-0.678,0.721-0.988,1.104
		c-0.207,0.254-0.388,0.521-0.576,0.784c-0.092,0.131-0.195,0.256-0.283,0.388c-0.214,0.324-0.405,0.66-0.592,0.998
		c-0.046,0.083-0.1,0.162-0.143,0.245c-0.183,0.347-0.342,0.701-0.495,1.056c-0.037,0.086-0.082,0.168-0.116,0.256
		c-0.14,0.341-0.256,0.689-0.369,1.038c-0.036,0.112-0.08,0.219-0.113,0.33c-0.095,0.321-0.17,0.646-0.242,0.971
		c-0.033,0.147-0.076,0.293-0.106,0.442c-0.058,0.3-0.095,0.604-0.134,0.907c-0.024,0.177-0.057,0.351-0.074,0.53
		c-0.028,0.303-0.034,0.607-0.045,0.912c-0.006,0.167-0.024,0.332-0.024,0.498v4.792c0,8.216,6.66,14.876,14.876,14.876h155.796
		c8.216,0,14.876-6.66,14.876-14.876V29.752h233.225v174.807H196.156c-8.216,0-14.876,6.66-14.876,14.876v163.644
		c0,8.216,6.66,14.876,14.876,14.876h296.059c8.215,0,14.876-6.66,14.876-14.876V219.435
		C507.091,211.219,500.43,204.559,492.215,204.559z M50.691,162.246L160.705,51.06v111.186H50.691z M477.339,368.203H211.032
		V234.311h266.308V368.203z" style="fill:#507C5C;"/>
            <path d="M255.692,313.875l-16.073,27.302c-0.771,1.211-2.312,1.761-4.073,1.761
		c-4.734,0-11.45-3.743-11.45-8.476c0-0.991,0.33-1.981,0.992-3.082l19.046-29.393l-18.275-29.283
		c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.275-8.148,11.12-8.148c2.422,0,4.073,0.881,5.174,2.862l14.642,25.54
		l14.641-25.54c1.101-1.981,2.754-2.862,5.175-2.862c4.844,0,11.12,3.523,11.12,8.148c0,1.101-0.332,2.202-1.101,3.413
		l-18.275,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.715,8.476-11.449,8.476
		c-1.761,0-3.413-0.55-4.073-1.761L255.692,313.875z" style="fill:#507C5C;"/>
            <path d="M301.595,342.277c-3.744,0-7.487-1.761-7.487-5.284v-70.017c0-3.633,4.295-5.174,8.586-5.174
		c4.295,0,8.586,1.541,8.586,5.174v60.329h25.1c3.304,0,4.955,3.744,4.955,7.487c0,3.743-1.651,7.486-4.955,7.486h-34.786V342.277z"
                  style="fill:#507C5C;"/>
            <path d="M381.294,320.7c0-13.321-34.899-11.01-34.899-36.77c0-16.514,14.422-22.788,28.182-22.788
		c5.836,0,21.909,1.101,21.909,9.689c0,2.972-1.981,9.027-6.827,9.027c-3.963,0-6.055-4.183-15.083-4.183
		c-7.816,0-11.008,3.192-11.008,6.605c0,11.01,34.899,8.918,34.899,36.66c0,15.853-11.56,24.44-27.523,24.44
		c-14.421,0-26.531-7.045-26.531-14.312c0-3.744,3.304-9.248,7.486-9.248c5.175,0,8.476,8.148,18.715,8.148
		C375.68,327.967,381.294,325.985,381.294,320.7z" style="fill:#507C5C;"/>
            <path d="M433.473,313.875l-16.073,27.302c-0.772,1.211-2.313,1.761-4.073,1.761
		c-4.735,0-11.449-3.743-11.449-8.476c0-0.991,0.33-1.981,0.991-3.082l19.046-29.393l-18.275-29.283
		c-0.771-1.211-1.101-2.312-1.101-3.413c0-4.623,6.276-8.148,11.12-8.148c2.422,0,4.073,0.881,5.175,2.862l14.642,25.54
		l14.642-25.54c1.099-1.981,2.752-2.862,5.174-2.862c4.845,0,11.12,3.523,11.12,8.148c0,1.101-0.33,2.202-1.101,3.413
		l-18.274,29.283l19.046,29.393c0.66,1.101,0.991,2.092,0.991,3.082c0,4.734-6.717,8.476-11.449,8.476
		c-1.763,0-3.414-0.55-4.073-1.761L433.473,313.875z" style="fill:#507C5C;"/>
          </g>
        </svg>
      </div>
      <div class="info">
        <h4 class="name">
          {{ file?.name }}
        </h4>
        <p class="size">
          {{ formatBytes(file?.size, 0) }}
        </p>
      </div>

      <div (click)="deleteFile(i)" class="delete">
        <svg height="18" viewBox="0 0 14 18" width="14" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" fill="#011e41ab"
                fill-rule="nonzero"/>
        </svg>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="{send:false, files: files}" cdkFocusInitial mat-button>{{ dialog['cancelBtn'] }}</button>
  <button *ngIf="files.length > 0" [mat-dialog-close]="{send:true, files: files, extraData: extraData}" mat-button>{{ dialog['confirmBtn'] }}
    <mat-icon>upload_file</mat-icon>
  </button>
</mat-dialog-actions>
